module.exports = __webpack_public_path__ + "img/titimg3.bcdeffa5.png";